import { FileTextIcon, TruckIcon } from "lucide-react"

import { ExtendedAddressRO } from "@/lib/storefront/addresses/address"
import { cn } from "@/components/ui/helpers/utils"

interface AddressFieldsProps {
  address: ExtendedAddressRO
  isB2B: boolean
  className?: string
  showEligibleIcons?: boolean
}

const OptionalSpan = ({ value, classname = "" }) =>
  value ? <span className={cn("text-nowrap", classname)}>{value}</span> : null
const OptionalDiv = ({ value, classname = "" }) =>
  value ? <div className={cn("text-nowrap", classname)}>{value}</div> : null

function AddressFieldsB2B({ a }: { a: ExtendedAddressRO }) {
  return (
    <>
      {a && (
        <>
          <div className="flex flex-col gap-y-px items-start">
            {/*    <div className="flex flex-row gap-x-[0.2rem]">
        <OptionalSpan value={a.title} />
        <OptionalSpan value={a.aristocraticTitle} />
        <OptionalSpan value={a.jobTitle} />
        <OptionalSpan value={a.honorific} />
        <OptionalSpan value={a.firstName} />
        <OptionalSpan value={a.secondName} />
        <OptionalSpan value={a.lastName} />
        <OptionalSpan value={a.secondLastName} />
      </div>*/}
            <OptionalDiv value={a.companyName1} />
            <OptionalDiv value={a.companyName2} />
            <OptionalDiv value={a.addressLine1} />
            <OptionalDiv value={a.addressLine2} />
            <div className="flex flex-row gap-x-[0.2rem]">
              {/*<OptionalSpan value={a.countryCode} />*/}
              <OptionalSpan value={a.postalCode} />
              <OptionalSpan value={a.city} />
            </div>
            <OptionalSpan value={a.country} />
          </div>

          <div className="flex flex-col gap-y-px items-start">
            <div className="flex flex-row flex-wrap gap-x-[0.2rem]">
              <OptionalSpan value={a.title} />
              {/*<OptionalSpan value={a.aristocraticTitle} />*/}
              {/*<OptionalSpan value={a.jobTitle} />*/}
              <OptionalSpan value={a.honorific} />
              <OptionalSpan value={a.firstName} />
              {/*<OptionalSpan value={a.secondName} />*/}
              <OptionalSpan value={a.lastName} />
              {/*<OptionalSpan value={a.secondLastName} />*/}
            </div>
            {/*  <OptionalDiv value={a.companyName1} />
        <OptionalDiv value={a.companyName2} />*/}
            {/*  <OptionalDiv value={a.addressLine1}/>
      <OptionalDiv value={a.addressLine2}/>*/}
            {/*<OptionalDiv value={a.addressLine3} />*/}
            {/*<OptionalDiv value={a.postBox} />*/}
            {/*<OptionalDiv value={a.mainDivision} />*/}
            {/*<OptionalDiv value={a.mainDivisionName} />*/}
            {/*<OptionalDiv value={a.subDivision} />*/}
            {/*<OptionalDiv value={a.subDivisionName} />*/}

            <OptionalDiv value={a.email} />
            {/*<OptionalDiv value={a.phoneMobile} />*/}
            {/*<OptionalDiv value={a.phoneHome} />*/}
            <OptionalDiv value={a.phoneBusiness} />
            {/*
      <OptionalDiv value={a.urn} />
*/}

            {/*<OptionalDiv value={a.phoneBusinessDirect} />*/}
            {/*<OptionalDiv value={a.fax} />*/}
          </div>
        </>
      )}
    </>
  )
}

function AddressFieldsB2C({ a }: { a: ExtendedAddressRO }) {
  return (
    <>
      {a && (
        <>
          <div className="flex flex-col gap-y-px items-start">
            <div className="flex flex-row flex-wrap gap-x-[0.2rem]">
              <OptionalSpan value={a.title} />
              {/*<OptionalSpan value={a.aristocraticTitle} />*/}
              {/*<OptionalSpan value={a.jobTitle} />*/}
              <OptionalSpan value={a.honorific} />
              <OptionalSpan value={a.firstName} />
              {/*<OptionalSpan value={a.secondName} />*/}
              <OptionalSpan value={a.lastName} />
              {/*<OptionalSpan value={a.secondLastName} />*/}
            </div>

            <OptionalDiv value={a.addressLine1} />
            <OptionalDiv value={a.addressLine2} />
            {/*<OptionalDiv value={a.addressLine3} />*/}
            {/*<OptionalDiv value={a.postBox} />*/}
            {/*<OptionalDiv value={a.mainDivision} />*/}
            {/*<OptionalDiv value={a.mainDivisionName} />*/}
            {/*<OptionalDiv value={a.subDivision} />*/}
            {/*<OptionalDiv value={a.subDivisionName} />*/}
            <div className="flex flex-row gap-x-[0.2rem]">
              {/*<OptionalSpan value={a.countryCode} />*/}
              <OptionalSpan value={a.postalCode} />
              <OptionalSpan value={a.city} />
            </div>
            <OptionalSpan value={a.country} />
            {/*
      <OptionalDiv value={a.urn} />
*/}

            {/*<OptionalDiv value={a.phoneBusinessDirect} />*/}
            {/*<OptionalDiv value={a.fax} />*/}
          </div>
          <div className="flex flex-col items-start gap-y-px">
            <OptionalDiv value={a.email} />
            {/*<OptionalDiv value={a.phoneMobile} />*/}
            {/*<OptionalDiv value={a.phoneHome} />*/}
            <OptionalDiv value={a.phoneBusiness} />
            {/*  <OptionalDiv value={a.companyName1} />
        <OptionalDiv value={a.companyName2} />*/}
          </div>
        </>
      )}
    </>
  )
}

export function AddressFields(props: AddressFieldsProps) {
  const a = props.address ?? {}

  return (
    <div className={"flex w-full flex-col gap-2 justify-between"}>
      <div className={cn("grid w-full grid-cols-1 gap-x-4 gap-y-2 overflow-hidden md:grid-cols-2", props.className)}>
        {props.isB2B ? <AddressFieldsB2B a={props.address} /> : <AddressFieldsB2C a={props.address} />}
      </div>
      <div
        className={cn("hidden flex-row gap-2", {
          flex: props.showEligibleIcons,
        })}
      >
        <FileTextIcon
          className={cn("hidden size-3", {
            block: a.invoiceToAddress,
          })}
        />

        <TruckIcon
          className={cn("hidden size-3", {
            block: a.shipToAddress,
          })}
        />
      </div>
    </div>
  )
}
